import React, { useEffect, useState } from 'react';
import { Range } from 'rc-slider';
import { faOnRangeFilterApply } from '../analytics-services';
import './styles.scss';
import './index.css';
import 'rc-tooltip/assets/bootstrap.css';

const trackStyle = [{ backgroundColor: '#008cff', height: '6px' }];
const handleStyle = [
  {
    width: '24px',
    height: '24px',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: '#bcbcbc',
    borderRadius: '20px',
    marginTop: '-9px',
    boxShadow: 'none',
  },
  {
    width: '24px',
    height: '24px',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: '#bcbcbc',
    borderRadius: '20px',
    marginTop: '-9px',

    boxShadow: 'none',
  },
];

const newStyle = { height: '6px', minHeight: '6px' };

const Slider = ({
  min,
  max,
  stepSize,
  prefix = '',
  suffix = '',
  applyRange,
  appliedRange,
  filterUrlParam,
}) => {
  const [tempRange, setTempRange] = useState([min, max]);

  const onSliderChange = value => {
    setTempRange(value);
  };

  const applyFilter = (values = []) => {
    faOnRangeFilterApply(filterUrlParam, values.join('_'));
    applyRange([values.join('_')], {
      prop54: `filter_apply_ui_<urlParam>_${values.join('_')}`,
    });
  };

  useEffect(() => {
    setTempRange(appliedRange);
  }, [appliedRange]);

  return (
    <div className="sliderfiltersOuter">
      <>
        <div className="rangeSlider">
          <Range
            trackStyle={trackStyle}
            handleStyle={handleStyle}
            newStyle={newStyle}
            allowCross={false}
            min={min}
            max={max}
            value={tempRange}
            onChange={onSliderChange}
            step={stepSize}
            onAfterChange={applyFilter}
          />
        </div>
        <div className="rangeValues">
          <span>
            {prefix}
            {Number.prototype.toLocaleString.call(+(tempRange?.[0] || ''))}
            {suffix}
          </span>
          <span>
            {prefix}
            {Number.prototype.toLocaleString.call(+(tempRange?.[1] || ''))}
            {suffix}
          </span>
        </div>
      </>
    </div>
  );
};

export default Slider;
